<template>
  <div id="social">
    <div class="content-wrapper">
      <portal to="action-buttons">
        <ul class="navbar-nav ml-md-auto">
          <li class="nav-item">
            <a :href="widgetUrl" target="_blank" class="navbar-nav-link">
              {{ this.$t("event.buttons.embed") }}
              <i class="icon-embed2 ml-1"></i>
            </a>
          </li>
          <li class="nav-item">
            <a
              href="javascript:;"
              class="navbar-nav-link"
              @click="isFilterEnabled = !isFilterEnabled"
            >
              {{ this.$t("event.components.participants.navbar.filterRecord") }}
              <i
                class="fas fa-search ml-1"
                :class="
                  $store.state.social.filter.searchTerm != null &&
                  $store.state.social.filter.searchTerm != ''
                    ? 'animate__animated animate__pulse animate__infinite text-info'
                    : ''
                "
              ></i>
            </a>
          </li>

          <li class="nav-item">
            <a
              href="javascript:;"
              class="navbar-nav-link"
              @click="addPostModal = true"
            >
              {{ this.$t("event.buttons.announcement") }}
              <i class="icon-plus3 ml-1"></i>
            </a>
          </li>
        </ul>
      </portal>
      <div class="content animated fadeIn">
        <transition name="slide-fade">
          <div v-if="isFilterEnabled" class="filter-card card card-collapsed">
            <div class="card-header header-elements-inline">
              <h5 class="card-title">
                {{
                  this.$t("event.components.participants.navbar.filterRecord")
                }}
              </h5>

              <div class="header-elements">
                <div class="list-icons">
                  <el-button-group>
                    <el-button
                      size="mini"
                      @click="$store.state.social.filter.searchTerm = ''"
                      round
                      >{{ $t("event.buttons.reset") }}</el-button
                    >
                    <el-button
                      size="mini"
                      type="danger"
                      @click="isFilterEnabled = false"
                      round
                      >{{ $t("event.buttons.close") }}</el-button
                    >
                  </el-button-group>
                </div>
              </div>
            </div>

            <div class="card-body">
              <div class="row">
                <div class="form-group col-md-12">
                  <el-input
                    clearable
                    v-model="$store.state.social.filter.searchTerm"
                    :placeholder="$t('event.textbox.speakerFilter')"
                  ></el-input>
                </div>
              </div>
            </div>
          </div>
        </transition>

        <div class="card">
          <div
            class="card-header header-elements-inline"
            style="padding-bottom: 0px"
          >
            <h5 class="card-title">{{ this.$t("event.menu.socialhub.title") }}</h5>

            <div class="header-elements">
              <el-button-group>
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="$t('event.buttons.helpdesk')"
                  placement="top"
                >
                  <el-button
                    @click="$helpMe(null)"
                    icon="fas fa-life-ring"
                    size="mini"
                  ></el-button>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="$t('event.buttons.refresh')"
                  placement="top"
                >
                  <el-button
                    icon="fas fa-redo-alt"
                    size="mini"
                    @click="$store.dispatch('getSocials')"
                  ></el-button>
                </el-tooltip>
              </el-button-group>
            </div>
          </div>

          <PageCountInfo
            :total="$store.state.social.filter.total"
            :skip="skip"
            :take="take"
          />

          <div class="row" style="margin: 0px 10px">
            <div
              v-for="(item, index) in $store.state.social.items"
              :key="item.id"
              class="col-lg-4 col-md-6 col-sm-12 col-xs-12"
            >
              <div class="post-item">
                <div
                  class="post-header"
                  style="
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    padding: 5px 10px;
                    border: 1px solid whitesmoke;
                  "
                >
                  <div
                    class="avatar"
                    style="
                      width: 40px;
                      height: 40px;
                      border-radius: 50%;
                      margin: 0px 10px;
                      background-color: whitesmoke;
                    "
                    :style="
                      'background-image: url(' +
                      ($store.state.social.users.some(
                        (k) => k.id == item.userID
                      )
                        ? $store.state.social.users.find(
                            (k) => k.id == item.userID
                          ).image
                        : $store.state.event.event.logo) +
                      '); background-size: cover'
                    "
                  ></div>
                  <div
                    style="
                      display: flex;
                      flex-direction: column;
                      align-items: flex-start;
                      flex: 1;
                      line-height: 15px;
                    "
                  >
                    <span style="font-weight: bold">
                      {{
                        $store.state.social.users.some(
                          (k) => k.id == item.userID
                        )
                          ? $store.state.social.users.find(
                              (k) => k.id == item.userID
                            ).fullName
                          : $store.state.event.event.title
                      }}
                    </span>
                    <span style="color: grey">{{
                      $moment(item.createDate).fromNow()
                    }}</span>
                  </div>
                  <el-popconfirm
                    :confirmButtonText="$t('event.variables.yes')"
                    :cancelButtonText="$t('event.variables.no')"
                    icon="el-icon-info"
                    iconColor="red"
                    :title="$t('sureToDel_')"
                    @confirm="deleteItem(index)"
                  >
                    <i
                      slot="reference"
                      style="color: grey; font-size: 17px; cursor: pointer"
                      class="fas fa-trash"
                    ></i>
                  </el-popconfirm>
                </div>
                <div class="post-content">
                  <p
                    class="content"
                    style="margin: 0px; padding: 5px 10px; margin: 10px 0px"
                  >
                    {{ getDescription(item) }}
                  </p>
                  <div class="post-image" v-if="item.image != null">
                    <el-image
                      style="width: 100%; height: 200px"
                      fit="cover"
                      :src="item.image"
                      :preview-src-list="[item.image]"
                    ></el-image>
                  </div>
                </div>
                <div class="post-footer" style="padding-bottom: 5px">
                  <a
                    @click="
                      $store.dispatch('getPostLikes', item.id);
                      postLikeModal = true;
                    "
                    href="javascript:;"
                    style="margin-left: 10px; color: #333; margin-right: 15px"
                  >
                    <i class="fa fa-heart"></i>
                    {{ item.likeCount }} {{ $t("event.variables.like") }}
                  </a>
                  <a
                    href="javascript:;"
                    @click="
                      $store.dispatch('getComments', item.id);
                      commentModal = true;
                    "
                    style="margin-left: 10px; color: #333; margin-right: 15px"
                  >
                    <i class="fa fa-comment"></i>
                    {{ item.commentCount }} {{ $t("event.variables.comment") }}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      :title="$t('comments')"
      width="670px"
      :visible.sync="commentModal"
    >
      <div
        v-if="$store.state.social.comments.length == 0"
        style="text-align: center; padding: 10px 15px"
      >
        {{ $t("noComment") }}
      </div>
      <div
        class="post-item"
        v-for="(item, index) in $store.state.social.comments"
        style="margin: 10px"
        :key="item.id"
      >
        <div
          class="post-header"
          style="
            display: flex;
            flex-direction: row;
            align-items: center;
            padding: 5px 10px;
            border: 1px solid whitesmoke;
          "
        >
          <div
            class="avatar"
            style="
              width: 40px;
              height: 40px;
              border-radius: 50%;
              margin: 0px 10px;
            "
            :style="
              'background-image: url(' +
              $store.state.social.commentUsers.find((k) => k.id == item.userID)
                .image +
              '); background-size: cover'
            "
          ></div>
          <div
            style="
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              flex: 1;
              line-height: 15px;
            "
          >
            <span style="font-weight: bold">
              {{
                $store.state.social.commentUsers.find(
                  (k) => k.id == item.userID
                ).fullName
              }}
            </span>
            <span style="color: grey">{{
              $moment(item.createDate).fromNow()
            }}</span>
          </div>
          <el-popconfirm
            :confirmButtonText="$t('event.variables.yes')"
            :cancelButtonText="$t('event.variables.no')"
            icon="el-icon-info"
            iconColor="red"
            :title="$t('delComment')"
            @confirm="deleteComment(index)"
          >
            <i
              slot="reference"
              style="color: grey; font-size: 17px; cursor: pointer"
              class="fas fa-trash"
            ></i>
          </el-popconfirm>
        </div>
        <div class="post-content">
          <p
            class="content"
            style="margin: 0px; padding: 5px 10px; margin: 10px 0px"
          >
            {{ getDescription(item) }}
          </p>
          <div class="post-image  " v-if="item.image != null">
            <el-image
              style="width: 100%; height: 200px"
              fit="cover"
              :src="item.image"
              :preview-src-list="[item.image]"
            ></el-image>
          </div>
        </div>
        <div class="post-footer" style="padding-bottom: 5px">
          <a
            href="javascript:;"
            style="margin-left: 10px; color: #333; margin-right: 15px"
            @click="
              $store.dispatch('getCommentLikes', item.id);
              commentLikeModal = true;
            "
          >
            <i class="fa fa-heart"></i>
            {{ item.likeCount }} {{ $t("event.variables.like") }}
          </a>
          <template v-if="item.subCommentCount != 0">
            <a
            href="javascript:;"
            @click="
              $store.dispatch('getSubComments', {
                index: index,
                id: item.postID,
              })
            "
            style="margin-left: 10px; color: #333; margin-right: 15px"
          >
            <i class="fa fa-comment"></i>
            {{ item.subCommentCount }} {{ $t("event.variables.comment") }}
          </a>
          </template>
        </div>

        <div
          class="post-item"
          v-for="(comment, subCommentIndex) in item.subComments"
          style="margin: 10px"
          :key="comment.id"
        >
          <div
            class="post-header"
            style="
              display: flex;
              flex-direction: row;
              align-items: center;
              padding: 5px 10px;
              border: 1px solid whitesmoke;
            "
          >
            <div
              class="avatar"
              style="
                width: 40px;
                height: 40px;
                border-radius: 50%;
                margin: 0px 10px;
              "
              :style="
                'background-image: url(' +
                $store.state.social.commentUsers.find(
                  (k) => k.id == item.userID
                ).image +
                '); background-size: cover'
              "
            ></div>
            <div
              style="
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                flex: 1;
                line-height: 15px;
              "
            >
              <span style="font-weight: bold">
                {{
                  $store.state.social.users.find((k) => k.id == item.userID)
                    .fullName
                }}
              </span>
              <span style="color: grey">{{
                $moment(item.createDate).fromNow()
              }}</span>
            </div>
            <el-popconfirm
              :confirmButtonText="$t('event.variables.yes')"
              :cancelButtonText="$t('event.variables.no')"
              icon="el-icon-info"
              iconColor="red"
              :title="$t('delComment')"
              @confirm="deleteSubComment({ index, subCommentIndex })"
            >
              <i
                slot="reference"
                style="color: grey; font-size: 17px; cursor: pointer"
                class="fas fa-trash"
              ></i>
            </el-popconfirm>
          </div>
          <div class="post-content">
            <p
              class="content"
              style="margin: 0px; padding: 5px 10px; margin: 10px 0px"
            >
              {{ getDescription(item) }}
            </p>
            <div class="post-image" v-if="item.image != null">
              <el-image
                style="width: 100%; height: 200px"
                fit="cover"
                :src="item.image"
                :preview-src-list="[item.image]"
              ></el-image>
            </div>
          </div>
          <div class="post-footer" style="padding-bottom: 5px">
            <a
              href="javascript:;"
              @click="
                $store.dispatch('getCommentLikes', comment.id);
                commentLikeModal = true;
              "
              style="margin-left: 10px; color: #333; margin-right: 15px"
            >
              <i class="fa fa-heart"></i>{{ item.likeCount }} {{ $t("event.variables.like") }}
            </a>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="$store.state.social.filter.page"
      :page-sizes="[20, 30, 40, 50]"
      :page-size="100"
      layout="total, sizes, prev, pager, next, jumper"
      :total="$store.state.social.filter.total"
    ></el-pagination>

    <el-dialog
      :visible.sync="addPostModal"
      width="710px"
      :title="$t('event.buttons.announcement')"
    >
      <PostAddUpdate
        @deleteMe="deleteItem"
        @closeMe="addPostModal = false"
        @itemUpdated="itemUpdated"
        @itemAdded="itemAdded"
        :data="updateForm"
      />
    </el-dialog>

    <el-dialog :visible.sync="postLikeModal" :title="$t('likes')">
      <div
        v-if="$store.state.social.postLikes.length == 0"
        style="text-align: center; padding: 10px 15px"
      >
        {{ $t("noLike") }}
      </div>
      <div class="card" v-else>
        <ul style="margin: 0; list-style: none; margin: 10px 0px; padding: 0px">
          <li
            v-for="item in $store.state.social.postLikes"
            :key="item.id"
            style="margin: 10px 15px"
          >
            <ParticipantMini :data="item" />
          </li>
        </ul>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="commentLikeModal" :title="$t('likes')">
      <div class="card">
        <ul style="margin: 0; list-style: none; margin: 10px 0px; padding: 0px">
          <li
            v-for="item in $store.state.social.commentLikes"
            :key="item.id"
            style="margin: 10px 15px"
          >
            <ParticipantMini :data="item" />
          </li>
        </ul>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import PostAddUpdate from "../../components/PostAddUpdate";
import ExcelImport from "../../components/ExcelImport";
import axios from "axios";
import PageCountInfo from "../../components/PageCountInfo";
import ParticipantMini from "../../components/ParticipantMini";
import $ from "jquery";
export default {
  metaInfo: {
    title: "Social hub",
  },
  components: { PostAddUpdate, ExcelImport, PageCountInfo, ParticipantMini },
  name: "Social",
  data() {
    return {
      widgetUrl:
        "https://cdn.holacon.com/widgets/event-gallery.html?eventID=" +
        this.$store.state.event.event.id +
        "&applicationID=" +
        this.$store.state.event.event.applicationID,

      modalVisible: false,
      updateForm: null,
      isFilterEnabled: false,
      timeout: null,
      excelDialog: false,
      helpUrl: this.$helpUrl + "areamaps",
      questionsVisible: false,
      title: null,
      commentModal: false,
      addPostModal: false,
      postLikeModal: false,
      commentLikeModal: false,
    };
  },
  methods: {
    getDescription(item) {
      var title = item.title;
      if (item.taggedUserIDs == null) return title;
      item.taggedUserIDs.map((i) => {
        title = title.replace(
          "%" + i + "%",
          this.$store.state.social.users.find((k) => k.id == i).fullName
        );
      });
      return title;
    },
    async confirm(index) {
      this.$store.dispatch("confirmQuestion", { index, context: this });
      this.$store.state.social.questions[index].status = 1;
    },
    async reject(index) {
      this.$store.dispatch("rejectQuestion", { index, context: this });
      this.$store.state.social.questions[index].status = 10;
    },
    async getQuestions(id, title) {
      this.title = title;
      await this.$store.dispatch("getWallQuestions", id);
      this.questionsVisible = true;
    },
    goWall(wall) {
      window.open(
        "https://vote.holacon.com/ask-to-speaker?ApplicationID=" +
          this.$store.state.event.event.applicationID +
          "&EventID=" +
          this.$store.state.event.event.id +
          "&WallID=" +
          wall.id,
        "_blank"
      );
    },
    itemUpdated(item) {
      var index = this.$store.state.social.items.findIndex(
        (k) => k.id == item.id
      );
      if (index != -1) {
        this.$store.state.social.items.splice(index, 1, item);
      }
    },
    itemAdded(item) {
      this.$store.dispatch("getSocials");
    },
    handleSizeChange(take) {
      this.$store.commit("setSocialTake", take);
    },
    handleCurrentChange(page) {
      $("html, body").animate({ scrollTop: 0 }, 350);
      this.$store.commit("setSocialPage", page);
    },
    deleteItem(index) {
      this.$store.dispatch("deletePost", { index, context: this });
    },
    deleteComment(index) {
      this.$store.dispatch("deleteComment", { index, context: this });
    },
    deleteSubComment(payload) {
      this.$store.dispatch("deleteSubComment", { ...payload, context: this });
    },
    statusChanged(value, index) {
      this.$store.dispatch("toggleSocial", { index, value });
    },
    handleSelectionChange(items) {
      this.$store.commit("setSelectedSocials", items);
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.isActive) {
        return "row-active";
      }
      return "row-passive";
    },
  },
  mounted() {
    this.$store.dispatch("getSocials");
    this.$store.dispatch("getRegistrationInputs");
  },
  created() {},
  computed: {
    skip() {
      return (
        (this.$store.state.social.filter.page - 1) *
        this.$store.state.social.filter.take
      );
    },
    take() {
      return this.skip + this.$store.state.social.items.length;
    },
  },
  watch: {
    "$store.state.social.filter.searchTerm": function () {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.$store.dispatch("getSocials");
      }, 500);
    },
  },
};
</script>

<style>
.post-item {
  border: 1px solid #ebebeb;
  border-radius: 3px;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/event/Social.vue